// src/data/services.js
import ResidentialBuildingBhangal from "../images/residentialBuildingBhangal.jpeg";
import ResidentialBuildingGoldhunga from "../images/ashan,ktm.jpeg";
import ResidentialBuildingKavresthali from "../images/residentialBuildingKavresthali.jpeg";
import InteriorDesignUttadhoka from "../images/interiorDesginUttardhoka.jpeg";
import InteriorDesignPanipokhari from "../images/interiorWorksPanipokhari.jpeg";
import DonfengCSJorpati from "../images/dongengWorshopEvJorpati.jpeg";
import DongfengCS from "../images/dongfengChargingStation.jpeg";
import BaristaClass from "../images/bristaClassSukhedhara.jpeg";
import CancerHospital from "../images/cancerHospitalHarisiddhi.jpeg";
import NorvicHospital from "../images/norvicHospital1.jpeg";
import LandStabalization from "../images/landStabilazationWorksIchyakamana.jpeg";
import BharatBenzPokhara from "../images/bharatbenzWorkshopPokhara.jpeg";
import CanopyWorks from "../images/canopyWorks.jpeg";
import CulinaryKitchen from "../images/culinarykitchenSukedhara.jpeg";
import EicherWS from "../images/eicherWorkshopItahari.jpeg";
import EicherWorkshop from "../images/eicherWorkshopSatungal.jpeg";
import GlassRoof from "../images/glassRoofBanasthali.jpeg";
import GovernmentSchool from "../images/govtSchoolChitwan.jpeg";
import WSTrainingCenter from "../images/workshopTrainingCenterJagati.jpeg";
import RoadCWork from "../images/roadConcreteWorkIchhyakamana.jpeg";
import PavingWork from "../images/pavingWorksPanipokhari.jpeg";
import WaterProofingWork from "../images/waterProofingWorksTarkeshwor.jpeg";
import ranibanResident from "../images/ranibanResident.jpeg"
import luintelSchool from "../images//luintelSchool.jpeg"
import roadDevelopmentWork from "../images/roadDevelopmentWork.jpeg"
import Man1 from "../images/man1.png";
import Man2 from "../images/man2.png";
import Man3 from "../images/man3.png";
import sushant from "../images/man2.png";
import women from "../images/women.png";
import budanilkantha from "../images/budanilkantha.jpeg"
import keystone from "../images/keystone.jpeg"
import crusherplantroshi from "../images/CrusherPlantroshi.jpeg"
import venturehirepurchase from "../images/VentureHIrePurchase.jpeg"
import roadproject from "../images/roadProject.jpeg"
import ashok from "../images/AshokLeylandSardi.jpeg"
import imeautomotive from "../images/ImeAutomotiveCorporateInterior.jpeg"
import imemotorsCoffice from "../images/imeMotorsCorporateOffice.jpeg"
import OjashWaterPlant from "../images/OjashWaterPlant.jpeg"
import sankuResident from "../images/sankuResidential.jpeg"

export const constructServices = [
  {
    title: "Construction",
    description:
      "We delivers a range of civil construction services which can be tailored to the different needs & objectives of our clients.",
    image: BharatBenzPokhara,
    process: "We plan develop and integrate",
  },
  {
    title: "Interior Design",
    description:
      "We provide a one-stop solution for all your interior need.From design to execution, we handle everything seamlessly.",
    image: NorvicHospital,
    process: "We plan develop and integrate",
  },
  {
    title: "Electrical",
    description:
      "We committed to providing the highest quality electrical, networking and related services exceeding our clients expectations.",
    image: DongfengCS,
    process: "We plan develop and integrate",
  },
  {
    title: "Concrete Work",
    description:
      "We Provide wide range of concrete products and professional paving installers from design to execution",
    image: PavingWork,
    process: "We plan develop and integrate",
  },
  {
    title: "Metal Works",
    description:
      "We are commited to meet the customers requirements by supply, febricating  quality metal products",
    image: CancerHospital,
    process: "We plan develop and integrate",
  },
];

export const tabs = [
  {
    label: "Civil Structure",
    numbers: [
      {
        id: "1",
        type: "Residential House",
        Place: "Bhangal,Kathmandu",
        image: ResidentialBuildingBhangal,
        description: "we made this house in Bhangal",
        reviews: [
          {
            message: "Excellent quality of work!",
            name: "Sushant Dhungana",
          },
        ],
      },
      {
        id: "2",
        type: "Residential House",
        Place: "Goldhunga,Kathmandu",
        image: ResidentialBuildingGoldhunga,
        description: "we made this house in Bhangal",
        reviews: [
          {
            message: "Excellent quality of work!",
            name: "Sushant Dhungana",
          },
        ],
      },
      {
        id: "3",
        type: "Residential House",
        Place: "Kavresthali,Kathmandu",
        image: ResidentialBuildingKavresthali,
        description: "we made this house in Bhangal",
        reviews: [
          {
            message: "Excellent quality of work!",
            name: "Sushant Dhungana",
          },
        ],
      },
      {
        id: "4",
        type: "Residential House",
        Place: "Budanilkantha,Kathmandu",
        image: budanilkantha,
        description: "we made this house in Bhangal",
        reviews: [
          {
            message: "Excellent quality of work!",
            name: "Sushant Dhungana",
          },
        ],
      },
      {
        id: "5",
        type: "Residential House",
        Place: "Sankhu,Kathmandu",
        image: sankuResident,
        description: "we made this house in Sankhu",
        reviews: [
          {
            message: "Excellent quality of work!",
            name: "Sushant Dhungana",
          },
        ],
      },
    ],
  },
  {
    label: "Interior Designs",
    numbers: [
      {
        id: "1",
        type: "Nepal Development Public Limited(NDPL)",
        Place: "Uttar Dhoka,Kathmandu",
        image: InteriorDesignUttadhoka,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
        reviews: [
          {
            message: "Excellent quality of work!",
            name: "Sushant Dhungana",
          },
        ],
      },
      {
        id: "2",
        type: "IME Complex",
        Place: "Panipokhari,Kathmandu",
        image: InteriorDesignPanipokhari,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "3",
        type: "Kathmandu Technical School",
        Place: "Sukhedhara,Kathmandu",
        image: BaristaClass,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "4",
        type: "Norvic Hospital",
        Place: "Thapathali,Kathmandu",
        image: NorvicHospital,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "5",
        type: "Residential House",
        Place: "Raniban,Kathmandu",
        image: ranibanResident,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "6",
        type: "Venture Hire Purchase",
        Place: "Kathmandu",
        image: venturehirepurchase,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "7",
        type: "IME Automotive Coprporate Office",
        Place: "Kathmandu",
        image: imeautomotive,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "8",
        type: "IME Motors Corporate",
        Place: "Kathmandu",
        image: imemotorsCoffice,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
    ],
  },
  {
    label: "Electrical",
    numbers: [
      {
        id: "1",
        type: "Service Center(Dongfeng)",
        Place: "Jorpati,Kathmandu",
        image: DonfengCSJorpati,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "2",
        type: "Charging Station(Dongfeng)",
        Place: "Boudha,Kathmandu",
        image: DongfengCS,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
    ],
  },
  {
    label: "Government Works",
    numbers: [
      {
        id: "1",
        type: "Land Stabalization",
        Place: "Icchyakamana,Chitwan",
        image: LandStabalization,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "2",
        type: "Government School",
        Place: "Chitwan",
        image: GovernmentSchool,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "4",
        type: "Road Concrete Work",
        Place: "Ichhyakamana,Chitwan",
        image: RoadCWork,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "5",
        type: "Road development Work",
        Place: "chepetar,Gorkha",
        image: roadDevelopmentWork,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "6",
        type: "Luintel School",
        Place: "Palungtar,Gorkha",
        image: luintelSchool,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "7",
        type: "Road Project",
        Place: "Palungtar,Gorkha",
        image: roadproject,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
    ],
  },
  {
    label: "Metal",
    numbers: [
      {
        id: "1",
        type: "Bharat Benz Workshop",
        Place: "Pokhara",
        image: BharatBenzPokhara,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "2",
        type: "Canopy Works",
        Place: "Kathmandu",
        image: CanopyWorks,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
      },
      {
        id: "3",
        type: "Culinary Kitchen",
        Place: "Sukhedhara,Kathmandu",
        image: CulinaryKitchen,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "4",
        type: "Eicher Workshop",
        Place: "Itahari",
        image: EicherWS,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
        },
      {
        id: "5",
        type: "Eicher Workshop",
        Place: "Satungal,Kathmandu",
        image: EicherWorkshop,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
        },
      {
        id: "6",
        type: "Glass Roof",
        Place: "Banasthali,Kathmandu",
        image: GlassRoof,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
        },
      {
        id: "7",
        type: "Workshop Training Center",
        Place: "Jagati,Bhaktapur",
        image: WSTrainingCenter,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
        },
      {
        id: "8",
        type: "Cancer Hospital",
        Place: "Harisiddhi,Lalitpur",
        image: CancerHospital,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
         },
         {
          id: "9",
          type: "Keystone Pvt Ltd",
          Place: "Naxal,Kathmandu",
          image: keystone,
          description:
            "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
            reviews: [{
              message:"Excellent quality of work!",
              name:"Sushant Dhungana",
            }
            ],
           },
           {
            id: "10",
            type: "Ashok Leyland Workshop",
            Place: "Sardi, Gandaki",
            image: ashok,
            description:
              "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
              reviews: [{
                message:"Excellent quality of work!",
                name:"Sushant Dhungana",
              }
              ],
             },
             {
              id: "11",
              type: "Ojash Water Plant",
              Place: "Kathmandu",
              image: OjashWaterPlant,
              description:
                "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
                reviews: [{
                  message:"Excellent quality of work!",
                  name:"Sushant Dhungana",
                }
                ],
               },
    ],
  },
  {
    label: "Concrete Works",
    numbers: [
      {
        id: "1",
        type: "Paving Work",
        Place: "Panipokhari,Kathmandu",
        image: PavingWork,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
        },
      {
        id: "2",
        type: "Water Proofing Work",
        Place: "Tarkeshwor,Kathmandu",
        image: WaterProofingWork,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
      {
        id: "3",
        type: "Crusher Plant Installation",
        Place: "Roshi, Kavre",
        image: crusherplantroshi,
        description:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi sunt quam pariatur quidem porro velit iusto sed fugiat dolore, unde voluptate iure minima voluptatem sapiente accusantium eius, nemo repellendus distinctio!",
          reviews: [{
            message:"Excellent quality of work!",
            name:"Sushant Dhungana",
          }
          ],
      },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Manzil Thapa",
    role: "Student",
    image: Man1,
    message:
      "Your passion and care for both your customers and colleagues are infectious and inspiring. You are so knowledgeable and supportive. Thank you for your support!",
  },
  {
    id: 2,
    name: "Roshan Adhikari",
    role: "Software Engineer",
    image: Man2,
    message:
      "Working with this team has been a fantastic experience. The professionalism and dedication are unmatched.",
  },
  {
    id: 3,
    name: "Sushant Dhungana",
    role: "Product Manager",
    image: sushant,
    message:
      "I highly appreciate the collaborative spirit of the team. Their insights and hard work have greatly contributed to our success.",
  },
  {
    id: 4,
    name: "Aayush Tamang",
    role: "Data Scientist",
    image: Man3,
    message:
      "The innovative approach and the focus on quality have made a significant impact on our projects.",
  },
  {
    id: 5,
    name: "Sneha Basnet",
    role: "UX Designer",
    image: women,
    message:
      "A truly inspiring experience working here. The emphasis on user-centric design is commendable.",
  },
];

export default testimonials;
